import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {KongService} from '../../kong.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-import-bpmn-dialog',
    templateUrl: './import-bpmn-dialog.component.html',
    styleUrls: ['./import-bpmn-dialog.component.scss']
})
export class ImportBpmnDialogComponent implements OnInit {

    file = {};

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ImportBpmnDialogComponent>) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    closeDialog() {
        this.dialogRef.close();
    }

    onFileDropped(file) {
        this.file['item'] = file[0];
        this.file['progress'] = 0;
    }

    fileBrowseHandler(file) {
        this.file['item'] = file[0];
        this.file['progress'] = 0;
    }

    deleteFile() {
        this.file = {};
    }

}
